module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"proposal":{"hint":"Чтобы создать нового демо-пользователя выберите его из списке"}},"en":{"proposal":{"hint":"To create a new demo user, please select him from the list"}}}')
  delete Component.options._Ctor
}
